(function () {
  'use strict';

  /* @ngdoc object
   * @name myPod.members
   * @description
   *
   */
  angular
    .module('myPod.members', [
      'ui.router'
    ]);
}());
